import { render, staticRenderFns } from "./purinvoiceview.vue?vue&type=template&id=278e1900&scoped=true&"
import script from "./purinvoiceview.vue?vue&type=script&lang=js&"
export * from "./purinvoiceview.vue?vue&type=script&lang=js&"
import style0 from "./purinvoiceview.vue?vue&type=style&index=0&id=278e1900&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278e1900",
  null
  
)

export default component.exports